import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import Calendar from './Calendar';
import messages from '../../../locale/messages';

const title = 'Calendar';

export default function action({ store, intl }) {

  const title = intl?.formatMessage(messages.calendar);

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  return {
    title,
    component: <AdminLayout><Calendar title={title} /></AdminLayout>,
  };
}
